import React, { useRef, useState } from 'react';
import { parseCSV } from './ImportHelpers';
import { Button } from 'antd';

type Props<T> = {
  onFileParsed: (data: T[]) => void;
  onDownloadTemplateClicked: () => void;
  onClearAllClicked: () => void;
};

const ImportComponent = <T extends object>({ onFileParsed, onDownloadTemplateClicked, onClearAllClicked }: Props<T>) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [_, setSelectedFile] = useState<File>();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setSelectedFile(file);
    handleImport(file);
  };

  const handleImport = (file?: File) => {
    if (file) {
      parseCSV(file)
        .then(data => {
          onFileParsed(data);
        })
        .catch(error => {
          // Handle the error
          console.error(error);
        })
        .finally(() => {
          setSelectedFile(undefined);
        });
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the file input value before opening the file dialog
      fileInputRef.current.click();
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'end' }}>
      <input type='file' accept='.csv' onChange={handleFileChange} style={{ display: 'none' }} ref={fileInputRef} />
      <Button style={{ marginRight: 5 }} onClick={onClearAllClicked}>
        Clear all
      </Button>
      <Button style={{ marginRight: 5 }} onClick={onDownloadTemplateClicked}>
        Download template
      </Button>
      <Button onClick={handleButtonClick}>Import</Button>
    </div>
  );
};

export default ImportComponent;
